import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ViewPackerMoverRequestService {
  constructor(private http:HttpClient) { }

  getPackerMoverById(data:any){
    return this.http.post(environment.apiUrl + "packersMovers/get/byId" , data)
  }
  // getPackerMoverById(data:any){
  //   return this.http.post(environment.apiUrl + "website/packersMovers/get/byId" , data)
  // }
}
